import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_PUBLIC_API_URL,
  headers: {
    "Content-Type":"application/json",
  },
  timeout: 30000
})
export default instance;